import React, { useEffect, useState, useLayoutEffect } from "react";
import InfiniteScroll from 'react-infinite-scroller';
import { useCategoryPageContext } from "../../contexts/app/CategoryPageContext";
import useWindowSize from "../../hooks/useWindowSize";
import Grid from "../grid/Grid";
import ProductCard1 from "../product-cards/ProductCard1";
import StyledCategoryGrid from './CategoryGridStyle';
import { useAppContext } from "../../contexts/app/AppContext";
import PuffLoader from 'react-spinners/PuffLoader'
import Backdrop from "../Backdrop";
import Box from "../Box";
import { useTranslation } from "react-i18next";

export interface CategoryPageProductsGridProps { }

interface Product {
  id: React.Key | null | undefined;
  url_key: any;
  base_image: { [x: string]: any };
  name: any;
  price: any;
  variants: any;
  attributes: any;
  sku: any;
  off: number,
  initialPrice: string
}

const CategoryPageProductsGrid: React.memo<CategoryPageProductsGridProps> = ({ view, setShowPage }) => {

  const [gridLg, setGridLg] = useState(0)
  const screenWidth = useWindowSize()
  const { setFooterVisible, fixPrice, setIsCategoryPage, imgsLoaded, setImgsLoaded } = useAppContext();
  const { categoryProducts, hasMore, loading, scrollDir, handleOnWheel, handleClick, threshold, filterApply, isSearch } = useCategoryPageContext();
  const { t } = useTranslation()
  const imgUrlArray = categoryProducts.map((pr) => {
    return pr.base_image['category_grid_image_url']
  })


  useLayoutEffect(() => {
   // console.log(categoryProducts);
  }, [])

  useEffect(() => {
    const imagesToLoad = imgUrlArray.length;
    let loadedImages = 0;

    const handleImageLoad = () => {
      loadedImages++;
      //if (loadedImages === imagesToLoad && !filterApply) { //moulopoulos

      //console.log('loadedImages1 => ', loadedImages)
      //console.log('imagesToLoad2 => ', imagesToLoad)
      //if (loadedImages == imagesToLoad) {
        // All images have loaded, update the state.
        setImgsLoaded(true);
      //}
    };

    // Dynamically create and load images from the URL array.
    /*imgUrlArray.forEach((imgUrl: string) => {
      const img = new Image();
      img.src = imgUrl;
      img.onload = handleImageLoad;
      img.onerror = handleImageLoad; // Handle errors as well (e.g., image not found).
    });*/
    setImgsLoaded(true);
    // Clean up any event listeners when the component unmounts.
    return () => {
      // Ensure to remove listeners from dynamically created images.
      imgUrlArray.forEach((imgUrl: string) => {
        const img = new Image();
        img.src = imgUrl;
        img.onload = null;
        img.onerror = null;
      });
    };
  }, [imgUrlArray])

  useEffect(() => {


    if (view === 'grid') {
      setGridLg(3)
    } else {
      setGridLg(4)
    }
  }, [view])


  useEffect(() => {
    setIsCategoryPage(true)
    if (hasMore) {
      setFooterVisible(false)

    } else {
      setFooterVisible(true)

    }
  }, [hasMore])


  return (
    <>
      {imgsLoaded ? <div id="scrollableDiv" >

      {isSearch && !categoryProducts.length && (
        <>
        <Box textAlign='center' mt={5}>{t("noresultssearch")}</Box>
        </>
      )}

        {/*isReverse={scrollDir == 'up' ? true : false} */}
        <InfiniteScroll threshold={threshold} isReverse={scrollDir == 'up' ? true : false} loadMore={loading} hasMore={hasMore}>
          <Grid
            //onClick={(event: any) => handleOnWheel(event)}
            //onMouseMove={(event: any) => handleOnWheel(event)}
            onTouchMove={(event: any) => handleOnWheel(event)}
            onWheel={(event: any) => handleOnWheel(event)}
            container spacing={4}>

            {categoryProducts?.map((product: Product, ind: number) => (

              <StyledCategoryGrid data-page_id={product?.page ?? 1} view={gridLg} id={product.id} item lg={gridLg} sm={6} md={4} xs={6} key={ind}>
                {/*price={product?.is_package === 1 || product?.show_total_price === 0 ? product?.product_price_discount : product?.price}*/}

                <ProductCard1

                  setShowPage={setShowPage}
                  onClick={((e: any) => handleClick(product.id, product.url_key, (product?.page ?? 1)))}
                  id={product.id}
                  urlKey={product.url_key}
                  imgUrl={product.base_image['category_grid_image_url']}
                  title={product.name}
                  rating={4}
                  price={product.show_total_price ? fixPrice(parseFloat(product.price)) : fixPrice(parseFloat(product?.product_price_discount))}
                  key={product.id}
                  variants={product.variants ?? []}
                  attributes={product.attributes}
                  sku={product.sku}
                  off={product.off}
                  initialPrice={product.is_package || !product.show_total_price ? fixPrice(parseFloat(product.product_price)) : fixPrice(parseFloat(product.initialPrice))}
                />

              </StyledCategoryGrid>
            ))}
          </Grid>

          {/*<FlexBox
        flexWrap="wrap"
        justifyContent="space-between"
        alignItems="center"
        mt="32px"
        >
        <SemiSpan>Showing 1-9 of 1.3k Products</SemiSpan>

        </FlexBox>*/}
          <PuffLoader
            color={'royalblue'}
            loading={hasMore}
            className='puffloader'
            size={60}
            aria-label="Loading Spinner"
            data-testid="loader"
          />

          <Backdrop open={filterApply} />

        </InfiniteScroll>

      </div> :
        <PuffLoader
          color={'royalblue'}
          loading={hasMore}
          className='puffloader'
          size={60}
          aria-label="Loading Spinner"
          data-testid="loader"
        />}
    </>
  )
}

export default CategoryPageProductsGrid;